import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";

/* ================= USER LAYOUT ================= */
import Header from "./client/components/Header";
import Footer from "./client/components/Footer";
// import AdminLayout from "./admin/components/AdminLayout";


/* ================= USER PAGES ================= */
import Home from "./client/pages/Home";
import About from "./client/pages/About";
import SignIn from "./client/pages/Signin";
import Register from "./client/pages/Register";
import Products from "./client/pages/Products";
import ProductDetails from "./client/pages/ProductDetails";
import Cart from "./client/pages/Cart";
import Blog from "./client/pages/Blog";
import BlogDetails from "./client/pages/BlogDetails";
import Checkout from "./client/pages/Checkout";
import Contact from "./client/pages/Contact";
import FAQ from "./client/pages/FAQ";
import ForgotPassword from "./client/pages/ForgotPassword";
import OrderTracking from "./client/pages/OrderTracking";
import OrderConfirmation from "./client/pages/OrderConfirmation";
import PrivacyPolicy from "./client/pages/PrivacyPolicy";
import TermsAndConditions from "./client/pages/TermsAndConditions";
import RequestQuote from "./client/pages/RequestQuote";
import Intro from "./client/pages/Intro";

/* ================= ADMIN ================= */
import AdminLogin from "./admin/pages/Login";
import AdminRegister from "./admin/pages/Register";
import Dashboard from "./admin/pages/Dashboard";
import AdminProducts from "./admin/pages/Products";
import Orders from "./admin/pages/Orders";
import Customers from "./admin/pages/Customers";
import RFQs from "./admin/pages/RFQs";
import Account from "./admin/pages/Account";
import PrivateRoute from "./admin/components/PrivateRoute";

/* ================= USER LAYOUT ================= */
function UserLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ================= USER ================= */}
        <Route element={<UserLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/products" element={<Products />} />
          <Route path="/productDetails/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blogdetails/:id" element={<BlogDetails />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/orderTracking" element={<OrderTracking />} />
          <Route path="/orderConfirmation" element={<OrderConfirmation />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/termsAndConditions" element={<TermsAndConditions />} />
          <Route path="/requestQuote" element={<RequestQuote />} />
          <Route path="/intro" element={<Intro />} />
        </Route>

        {/* ================= ADMIN ================= */}
        ✅ <Route path="/admin" element={<Navigate to="/admin/login" />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />

        <Route path="/admin/dashboard" element={
          <PrivateRoute><Dashboard /></PrivateRoute>
        } />

        <Route path="/admin/products" element={
          <PrivateRoute><AdminProducts /></PrivateRoute>
        } />

        <Route path="/admin/orders" element={
          <PrivateRoute><Orders /></PrivateRoute>
        } />

        <Route path="/admin/customers" element={
          <PrivateRoute><Customers /></PrivateRoute>
        } />

        <Route path="/admin/rfqs" element={
          <PrivateRoute><RFQs /></PrivateRoute>
        } />

        <Route path="/admin/account" element={
          <PrivateRoute><Account /></PrivateRoute>
        } />

        {/* ================= FALLBACK ================= */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
